import { QueryEntity } from "@datorama/akita";
import { map } from "rxjs/operators";
import { singleton } from "tsyringe";

import {
    WishlistProductStatusesState,
    WishlistProductStatusesStore,
} from "../stores/WishlistProductStatusesStore";

@singleton()
export class WishlistProductStatusesQuery extends QueryEntity<WishlistProductStatusesState> {
    public constructor(
        private readonly wishlistProductInfoStore: WishlistProductStatusesStore
    ) {
        super(wishlistProductInfoStore);
    }

    public selectProductInLoadingStatus(productId: number) {
        return this.select((state) => state.productsInLoading).pipe(
            map((statusItems) => {
                return !!statusItems.find(
                    (statusItem) => statusItem === productId
                );
            })
        );
    }

    public selectProductInWishlistStatus(productId: number) {
        return this.selectEntity(productId).pipe(
            map((productStatus) => productStatus?.productInWishlist)
        );
    }

    public selectVariantInWishlistStatus(productId: number, variantId: number) {
        return this.selectEntity(productId).pipe(
            map(
                (productStatus) =>
                    productStatus?.productInWishlist &&
                    productStatus?.variantsInWishlist.includes(variantId)
            )
        );
    }
}
